<template>
  <CustomDialog
    :visi.sync="visi"
    title="操作日志"
    @closed="resetRecord()">
    <div slot="content" class="content">
      <el-table
        v-loading="loading"
        :data="data"
        element-loading-text="加载中"
        fit
        >
        <el-table-column 
          label="操作人" 
          prop="operators"
          min-width="100">
        </el-table-column>
        <el-table-column 
          label="操作名称" 
          prop="action_name"
          min-width="200">
        </el-table-column>
        <el-table-column 
          label="操作内容"
          min-width="300">
          <template slot-scope="{row}">
            <el-scrollbar 
              :native="false"
              v-if="row.content &&
              row.content.length">
              <p 
                v-for="(item, index) in row.content"
                :key="index">
                {{item}}
              </p>
            </el-scrollbar>
            <span v-else class="no-data">无数据</span>
          </template>
        </el-table-column>
        <el-table-column 
          label="操作时间" 
          prop="create_time"
          min-width="180">
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button 
        plain 
        type="success" 
        size="small"
        @click="visi = false">
        我已知悉
      </el-button>
    </div>
  </CustomDialog>
</template>

<script>
import { GetLogRecord } from '@/api/index.js'
import { mapGetters, mapMutations } from 'vuex'
import { withLoadingApi } from '@/utils/hoc'
import { copyObj } from '@/utils'
export default {
  data () {
    return {
      visi: false,
      res: null,
      data: [],
      loading: false,

      currPage: 1,
      pageSize: 10
    }
  },
  computed: {
    ...mapGetters(['logRecord']),
    auth(){
      return this.$route.meta && this.$route.meta.auth
      ? this.$route.meta.auth
      : null;
    }
  },
  watch: {
    logRecord(val){
      let { LOG_VISI } = val;
      if(LOG_VISI && this.auth){
        let data = copyObj(val);
        delete data.LOG_VISI;
        this.initData(data);
        this.visi = true;
      }else{
        !this.auth && this.$message.info('当前页面没有配置权限，无法查看操作日志');
        this.resetRecord()
      }
    }
  },
  methods: {
    ...mapMutations(['LOG_RECORD']),
    initData(data = {}){
      withLoadingApi(
        GetLogRecord({page: this.currPage, limit: this.pageSize, ...data, auth: this.auth}),
        'loading',
        this
      ).then(res => {
        this.res = res;
        let { list } = res;
        this.data = list;
      })
    },
    resetRecord(){
      let data = { LOG_VISI: false };
      if(JSON.stringify(data) !== JSON.stringify(this.logRecord))
        this.LOG_RECORD(data);
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .el-table{
  @extend .custom-table;
  min-width: 100%;
  .el-scrollbar{
    .el-scrollbar__wrap{
      max-height: 500px;
      text-align: left;
      p{
        max-width: 100%;
        line-height: 1.5em;
        word-break: break-word;
        white-space: normal;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LogRecord.vue